module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAOCAYAAABO3B6yAAAAAXNSR0IArs4c6QAAALBJREFUOBFjNDExaf3//38JAwMDGxDTA/xiZGTsOXPmTDXYMmNj459AR1SFhobS3AEgO0xNTStBdsJ9CuT8p4flMAtBdoHshPEZUDhwUdoykO1koa1VuE0HOQKYFrYx4VZCexlg4vcaUAeAvDjqgAFLhMAE+AQYA9sGzAHAklAWngboXRCBLIYBUCL89eDBg2J6OAJkx/3790tBdsIcwAgsENqAnGIgpnldALUUpTICALH0NMRV5tJ9AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/containers/device/detail/images/battery.png
// module id = 965
// module chunks = 0